// Shared labels for invoice types (SOLY-INV-002). Single source for every
// surface listing invoices (project invoicing tab, org-wide registry page).

export const INVOICE_TYPES = ['deposit', 'final', 'standalone', 'credit_note'] as const
export type InvoiceType = (typeof INVOICE_TYPES)[number]

export function getInvoiceTypeLabel(type: string): string {
  if (type === 'deposit') return 'Acompte'
  if (type === 'final') return 'Facture finale'
  if (type === 'standalone') return 'Facture supplémentaire'
  if (type === 'credit_note') return 'Note de crédit'
  return type
}
